import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactNode } from "react";
import classes from "./CustomAccordion.module.scss";

const CustomAccordion = ({
  title,
  badge = false,
  badgeIcon = null,
  badgeCount = 0,
  children,
  size = "sm",
  defaultExpanded = false,
}: {
  title: string;
  badge?: boolean;
  badgeIcon?: ReactNode;
  badgeCount?: number;
  children: ReactNode;
  size?: "sm" | "md" | "lg";
  defaultExpanded?: boolean;
}) => {
  return (
    <Accordion
      className={classes["custom-accordion-container"]}
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummary
        className={`${classes["custom-accordion-header"]} ${
          classes[`header-${size}`]
        }`}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
      >
        {title}
        {badge && (
          <Typography component="div" className={classes["filterBadge"]}>
            {badgeIcon ? badgeIcon : badgeCount}
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails className={classes["custom-accordion-content"]}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
